import { Navigate, Outlet } from "react-router-dom";
import { Credentials } from "../../Store/Credentials";

const UnprotectedRoute = () => {
    return !Credentials.isAuthenticated ? <Outlet /> : <Navigate to="/ai" />;
};

export default UnprotectedRoute;
